import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { SystemMasterSelect } from '../../../Components/helper';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { FloatyButton } from '../../../Components/Floaty';
import { ProductGroupIcon, AddIcon } from '../../../bombiix-icon';

function BtnAddToGroup({ onBtnClick, options, handleOpenProductGroup, selectedIds }) {
  const { t } = useTranslation('common');

  return (
    // <CustomTooltip placement="top" tooltipText={t("FILTER.ADD_PRODUCT_GROUP")}>
    //   <button type="button" disabled={selectedIds?.length === 0} aria-label={t("FILTER.ADD_PRODUCT_GROUP")} className="btn">
    //     <OverlayTrigger
    //       // placement={t("TAKING_DATES.BUTTON")}
    //       placement="top"
    //       trigger="click"
    //       rootClose
    //       overlay={
    //         <Popover className="custom-popover">
    //           <Popover.Content>
    //             <div className="d-flex align-items-end">
    //               <div className="flex-fill">
    //                 <Select
    //                   options={options}
    //                   onChange={onBtnClick}
    //                   menuPlacement="top"
    //                   getOptionLabel={(option) => `${option.name}`}
    //                   getOptionValue={(option) => `${option._id}`}
    //                   classNamePrefix="common-select"
    //                   styles={SystemMasterSelect}
    //                   placeholder={t("FILTER.PRODUCT_GROUP")}
    //                 />
    //               </div>
    //               <CustomTooltip placement="top" tooltipText={t("COMMON_LABEL.ADD")}>
    //                 <button type="button" onClick={() => handleOpenProductGroup()} aria-label={t("COMMON_LABEL.ADD")} className="btn btn-outline sm ml-16 mr-0">
    //                   <span className="icon icon-Add-bold" />
    //                 </button>
    //               </CustomTooltip>
    //             </div>
    //           </Popover.Content>
    //         </Popover>
    //       }
    //     >
    //       <i className="icon-Product-Group f-26" />
    //     </OverlayTrigger>
    //   </button>
    // </CustomTooltip>
    <OverlayTrigger
      placement="top"
      trigger="click"
      rootClose
      overlay={
        <Popover className="custom-popover">
          <Popover.Content>
            <div className="d-flex align-items-end">
              <div className="flex-fill">
                <Select
                  options={options}
                  onChange={onBtnClick}
                  menuPlacement="top"
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  classNamePrefix="common-select"
                  styles={SystemMasterSelect}
                  placeholder={t('FILTER.PRODUCT_GROUP')}
                />
              </div>
              <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                <button type="button" onClick={() => handleOpenProductGroup()} aria-label={t('COMMON_LABEL.ADD')} className="btn btn-outline sm ml-16 mr-0">
                  <AddIcon size={24} />
                </button>
              </CustomTooltip>
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <FloatyButton
        icon={ProductGroupIcon}
        label={t('FILTER.ADD_PRODUCT_GROUP')}
        disabled={selectedIds?.length === 0}
        showTooltip={false}
      />
    </OverlayTrigger>
  );
}

export default BtnAddToGroup;
